var _path, _rect, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgStepDoneV2 = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.153 11.7124C21.9487 11.5273 21.6793 11.4308 21.4039 11.4441C21.1285 11.4574 20.8696 11.5794 20.6841 11.7834L14.34 18.7694L11.275 15.6534C11.0805 15.4624 10.8187 15.3554 10.5461 15.3555C10.2734 15.3556 10.0117 15.4627 9.81731 15.6539C9.62289 15.845 9.51129 16.1048 9.50656 16.3775C9.50184 16.6501 9.60437 16.9136 9.79206 17.1114L13.629 21.0114C13.7257 21.1098 13.841 21.188 13.9683 21.2414C14.0955 21.2948 14.2321 21.3223 14.37 21.3224H14.39C14.5317 21.3196 14.6713 21.2879 14.8002 21.2292C14.9292 21.1706 15.0448 21.0863 15.14 20.9814L22.224 13.1814C22.4092 12.9771 22.5057 12.7076 22.4924 12.4322C22.479 12.1568 22.357 11.8979 22.153 11.7124Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2.38281,
    width: 28,
    height: 28,
    rx: 14,
    stroke: "#F8F8F8",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 16.3828C32 25.2194 24.8366 32.3828 16 32.3828C7.16344 32.3828 0 25.2194 0 16.3828C0 7.54626 7.16344 0.382812 16 0.382812C24.8366 0.382812 32 7.54626 32 16.3828ZM4 16.3828C4 23.0102 9.37258 28.3828 16 28.3828C22.6274 28.3828 28 23.0102 28 16.3828C28 9.7554 22.6274 4.38281 16 4.38281C9.37258 4.38281 4 9.7554 4 16.3828Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStepDoneV2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/step-done-v2.a63e4e04.svg";
export { ForwardRef as ReactComponent };